import usStateCodes from 'us-state-codes';

/**
 * Parses URL params to default table display
 *
 * @param {string} searchString - URL search params
 * @param {string} dataType     - type from data attribute.
 * @returns {object} - Object of defaulted table filters
 */
export default function getSearchParams(searchString, dataType) {
  const type = dataType || '';
  const searchParams = new URLSearchParams(searchString);
  // Get penalty type
  const penaltyType = searchParams.get('penalty');
  let penaltyParam = null;

  // Output type from data-attribute if no penaltyType exists.
  if (type && ! penaltyType) {
    penaltyParam = 'readmission' === type ? type : 'hac';
  }

  // If we have a searchParam, ignore type.
  if (penaltyType && 'readmission' === penaltyType) {
    penaltyParam = 'readmission';
  } else if (penaltyType && 'hac' === penaltyType) {
    penaltyParam = 'hac';
  }

  // Get year
  const year = searchParams.get('penaltyYear');
  let yearParam = null;
  if (year && ! isNaN(year)) {
    yearParam = parseInt(year, 10);
  }
  // Get state
  const state = searchParams.get('state');
  let stateParam = null;
  if (state && usStateCodes.getStateNameByStateCode(state)) {
    stateParam = state;
  }
  return {
    penalty: penaltyParam,
    year: yearParam,
    state: stateParam,
  };
}
